import StoryTellingTiles from '@/components/homepage/StorytellingTiles/StorytellingTiles';

export default function StorytellingTilesBuilder({ header, subHeader, tiles }) {
  return <StoryTellingTiles header={header} subHeader={subHeader} tiles={tiles} />;
}
